export default __webpack_public_path__ + "static/media/pic1.3cd22178.jpg";